(() => {
    const fadingImagesContainers = document.querySelectorAll(
        '[data-fading-images-container]'
    );

    Array.from(fadingImagesContainers).forEach((fadeImagesContainer) => {
        let currentIndex = 0;
        const images = fadeImagesContainer.querySelectorAll('img, video');

        const update = () => {
            images.forEach((image, index) => {
                if (index === currentIndex) {
                    image.classList.remove('opacity-0');
                } else {
                    image.classList.add('opacity-0');
                }
            });

            currentIndex =
                currentIndex < images.length - 1 ? currentIndex + 1 : 0;

            setTimeout(update, 8000);
        };

        setTimeout(update, 8000);
    });
})();
